module.exports = __webpack_public_path__ + "media/club_product_v2/burger_menu-019d7f05.png";